/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizercreatetitle2Inputs */

const en_organizercreatetitle2 = /** @type {(inputs: Organizercreatetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create organizer`)
};

const de_organizercreatetitle2 = /** @type {(inputs: Organizercreatetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstalter anlegen`)
};

/**
* | output |
* | --- |
* | "Create organizer" |
*
* @param {Organizercreatetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizercreatetitle2 = /** @type {((inputs?: Organizercreatetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizercreatetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizercreatetitle2(inputs)
	return de_organizercreatetitle2(inputs)
});
export { organizercreatetitle2 as "organizerCreateTitle" }